import React from 'react';

import { defaultSpacing } from '../Grid/Grid.styles';
import { StyledBox } from './Box.styles';
import { IBoxProps } from './Box.types';

const Box = ({
  spacing = defaultSpacing,
  ...props
}: IBoxProps): JSX.Element => {
  return <StyledBox {...{ ...props, spacing }}>{props.children}</StyledBox>;
};

export default Box;
